import {
  Card as MuiCard,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
} from '@mui/material'
import GitHubIcon from '@mui/icons-material/GitHub'
import LaunchIcon from '@mui/icons-material/Launch'
import { Props } from '../types'

const Card = ({
  title,
  description,
  image,
  repository,
  address,
}: Props) => {
  return (
    <MuiCard sx={{ maxWidth: 345, marginBottom: `10px` }}>
      <CardMedia component="img" height="140" image={image} alt="Imagem" />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      {(repository || address) && (
        <CardActions>
          {repository?.length && (
            <IconButton aria-label="repository" size="large" href={repository}>
              <GitHubIcon />
            </IconButton>
          )}
          {address?.length && (
            <IconButton aria-label="repository" size="large" href={address}>
              <LaunchIcon />
            </IconButton>
          )}
        </CardActions>
      )}
    </MuiCard>
  )
}

export default Card
